import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const services = [
  {
    id: "facials",
    number: "01",
    name: "Tailored Relaxing Facials",
    summary: "Bespoke facials, calibrated to your skin on the day.",
    body: "A signature mobile facial tailored to your skin's needs — double cleansing, gentle exfoliation, steam, extraction (where appropriate), a custom mask, and a calming face & décolletage massage. Finished with serums and SPF chosen for your concerns. Perfect for hydration, glow, and pure unwinding.",
    duration: "60–90 min",
  },
  {
    id: "led",
    number: "02",
    name: "LED Light Therapy",
    summary: "Clinical-grade LED to calm, brighten and restore.",
    body: "Medical-grade LED light therapy targeting collagen production, redness, breakouts and uneven tone. Painless, deeply relaxing, and beautifully complementary to facials, peels and microneedling. Suitable for all skin types and a beautiful add-on for special occasions.",
    duration: "20–30 min",
  },
  {
    id: "meso",
    number: "03",
    name: "Mesotherapy",
    summary: "Targeted nutrient infusion for a luminous complexion.",
    body: "A skin-needling infusion of vitamins, antioxidants and bespoke active blends, delivered just below the skin's surface. Designed to address dullness, fine lines, dehydration, pigmentation and overall vitality — leaving the skin firmer, plumper and visibly fresher.",
    duration: "60 min",
  },
  {
    id: "peel",
    number: "04",
    name: "Chemical Peeling",
    summary: "Resurfacing chemistry for renewed clarity.",
    body: "Jalupro Glow Peel is an innovative professional-grade chemical peel designed to rejuvenate and brighten the skin. Formulated with a blend of powerful exfoliating and nourishing ingredients, it helps improve skin texture, reduce pigmentation, and promote a radiant complexion. The effective combination of high-quality ingredients stimulates collagen production and promotes natural skin regeneration. This peel works by gently removing dead skin cells, stimulating cell renewal, and enhancing skin hydration. Ideal for addressing signs of aging, dullness, and uneven skin tone, it helps achieve a smoother, more youthful appearance. Suitable for all skin types, it provides visible results with minimal downtime.",
    duration: "45 min",
  },
  {
    id: "microneedling",
    number: "05",
    name: "Microneedling",
    summary: "Collagen-induction therapy for firmer, finer skin.",
    body: "A collagen induction treatment using sterile, single-use heads to create controlled micro-channels — encouraging the skin to renew itself. Excellent for scarring, lines, lax texture and an overall firmer finish. Pairs beautifully with LED to amplify recovery and results.",
    duration: "75 min",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#FAEDE6] py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20">
          {/* Header */}
          <div className="lg:col-span-4 lg:sticky lg:top-32 lg:self-start">
            <div className="flex items-center gap-4 mb-8">
              <span className="h-px w-8 bg-[#B78782]" />
              <span className="text-[11px] tracking-[0.4em] uppercase text-[#B78782]">
                The Menu
              </span>
            </div>
            <h2 className="font-serif-display text-[#4A3737] text-4xl md:text-5xl lg:text-[58px] font-light leading-[1.05] tracking-tight">
              Mobile
              <br />
              treatments,
              <br />
              <em className="not-italic font-script text-[#B78782] text-5xl md:text-6xl lg:text-[68px]">
                refined.
              </em>
            </h2>
            <p className="mt-8 text-[15px] leading-relaxed text-[#4A3737]/80 font-light max-w-sm">
              A small, focused menu — each treatment honed and personalised. All
              services are quoted on enquiry and tailored to your skin and
              setting.
            </p>
          </div>

          {/* Accordion list */}
          <div className="lg:col-span-8" data-testid="services-list">
            <Accordion
              type="single"
              collapsible
              defaultValue="facials"
              className="w-full"
            >
              {services.map((s) => (
                <AccordionItem
                  key={s.id}
                  value={s.id}
                  data-testid={`service-${s.id}`}
                  className="border-b border-[#B78782]/25 border-t-0 border-x-0"
                >
                  <AccordionTrigger
                    data-testid={`service-trigger-${s.id}`}
                    className="hover:no-underline py-8 group"
                  >
                    <div className="flex items-baseline gap-6 md:gap-10 w-full text-left">
                      <span className="text-[11px] tracking-[0.32em] text-[#B78782] mt-2">
                        {s.number}
                      </span>
                      <div className="flex-1">
                        <h3 className="font-serif-display text-[#4A3737] text-2xl md:text-[34px] font-light leading-tight tracking-tight group-hover:text-[#B78782] transition-colors duration-300">
                          {s.name}
                        </h3>
                        <p className="mt-2 text-[13px] md:text-sm text-[#4A3737]/70 font-light">
                          {s.summary}
                        </p>
                      </div>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="pb-10">
                    <div className="pl-0 md:pl-[80px] grid grid-cols-1 md:grid-cols-12 gap-6">
                      <p className="md:col-span-8 text-[15px] leading-relaxed text-[#4A3737]/85 font-light">
                        {s.body}
                      </p>
                      <div className="md:col-span-4 flex flex-col gap-4">
                        <div>
                          <p className="text-[10px] tracking-[0.32em] uppercase text-[#B78782] mb-1">
                            Duration
                          </p>
                          <p className="text-sm text-[#4A3737] font-light">
                            {s.duration}
                          </p>
                        </div>
                        <div>
                          <p className="text-[10px] tracking-[0.32em] uppercase text-[#B78782] mb-1">
                            Investment
                          </p>
                          <p className="text-sm text-[#4A3737] font-light">
                            On enquiry
                          </p>
                        </div>
                        <a
                          href="#contact"
                          data-testid={`enquire-${s.id}`}
                          className="mt-2 inline-flex items-center text-[11px] tracking-[0.28em] uppercase border border-[#B78782] text-[#4A3737] px-5 py-3 hover:bg-[#B78782] hover:text-[#FAEDE6] transition-colors duration-300 self-start"
                        >
                          Enquire
                        </a>
                      </div>
                    </div>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
